/* eslint-disable */
import { createGettext } from "@jshmrtn/vue3-gettext";
import { createApp } from 'vue'
import translations from './translations.json'
const gettext = createGettext({
    availableLanguages: {
        en: "English",
        de: "Deutsch",
    },
    // defaultLanguage: "en",
    defaultLanguage: getUrlParameter('lang')? getUrlParameter('lang') : getConfig("lang"),
    translations: translations,
    silent: true
});
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import App from './App.vue'
import $ from 'jquery'

const app = createApp(App)

app.use(gettext);
app.use(Tooltip, {
    delay: 200,
    class: 'myTooltip',
    triggers: ['click'],
    offset: 0
});
app.config.productionTip = false
app.mount('.gfSensorToolVue3')


function getConfig(key)
{
    for (var i = 0; i < $(".gfSensorToolVue3 app").data("config")["props"].length; ++i)
    {
        if (JSON.parse($(".gfSensorToolVue3 app").data("config")["props"][i])["key"] == key)
        {
            return JSON.parse($(".gfSensorToolVue3 app").data("config")["props"][i])["value"];
        }
    }
}
function getUrlParameter(sParam)
{
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++)
    {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam)
        {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
    return false;
}

String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

